import React, {useState} from "react";
import PropTypes from "prop-types";
import {ACheckbox, ADivider, AIcon} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {DropdownMenu} from "components/DropdownMenu";
import BulkActionDeleteModal from "./BulkActionDeleteModal";
import BulkDeleteMenuItem from "./BulkDeleteMenuItem";
import css from "./BulkAction.module.scss";

const BulkAction = ({
  investigations = [],
  checked = false,
  indeterminate = false,
  disabled,
  handleOnSelect
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  return (
    <div
      className="bulk-action d-flex align-center"
      data-testid={`count-${investigations.length}`}>
      {/** Select-All Checkbox */}
      <ACheckbox
        checked={checked}
        className={classNames("bulk-action__checkbox", css.bulkActionCheckbox)}
        disabled={disabled}
        indeterminate={indeterminate && !checked}
        onClick={() => handleOnSelect(!checked)}
      />

      {/** Dropdown Menu */}
      <DropdownMenu
        chevron={false}
        buttonClass="bulk_action__toggle-btn px-1"
        buttonContent={<AIcon size={12}>caret-down</AIcon>}
        menuClass={classNames("bulk-action__menu-dropdown", css.menu)}
        menuPlacement={"bottom-left"}
        closeMenuOnClick={true}>
        <BulkDeleteMenuItem
          enabled={investigations.length > 0}
          setOpenModal={setDeleteModalOpen}
        />
      </DropdownMenu>

      {/** Delete investigations Modal */}
      <BulkActionDeleteModal
        investigations={investigations}
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
      />
    </div>
  );
};

BulkAction.propTypes = {
  investigations: PropTypes.array,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  handleOnSelect: PropTypes.func
};

export default BulkAction;
